export const CREATURE_DEATH_CALL = {
  copy: 'Enemy %1 succumbs to its wounds and perishes',
  direction: 'outbound',
};

export const CREATURE_DEATH_REWARD = {
  copy: 'You pick up %1 gold from your enemy',
  direction: 'outbound',
};
